import { useCallback, useEffect, useState } from 'react';

import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';

const useLabelManage = <T extends Record<string, unknown>>({
  activeItem,
  activeKey,
  setActiveItem,
  viewType,
  flattenedTree,
}: {
  activeKey: string;
  activeItem?: FlattenTreeResult<T>;
  setActiveItem: (item?: FlattenTreeResult<T>) => void;
  viewType?: 'new' | 'info';
  flattenedTree: FlattenTreeResult<T>[];
}) => {
  const [viewStatus, setViewStatus] = useState<'new' | 'info'>('info');

  useEffect(() => {
    if (viewType === 'new') {
      setViewStatus('new');
    } else {
      setViewStatus('info');
    }
  }, [viewType]);

  const onPanelClose = useCallback(
    (key?: string) => {
      setActiveItem(undefined);
      // data-id가 node.key인 html element요소 찾아서 foucs
      // Find the HTML element with the data-id attribute matching activeKey
      setTimeout(() => {
        const node = document.querySelector(`[data-id="${key || activeKey}"]`);

        // Ensure node is an HTMLElement before calling focus()
        if (node instanceof HTMLElement) {
          node.focus();
        }
      }, 500);
    },
    [setActiveItem, activeKey],
  );

  const namePath = activeItem?.namePath ?? '';
  const keyPath = activeItem?.keyPath ?? '';
  const depth = activeItem?.keyPath?.split('.').length ?? 1;

  const onNewCategoryClick = () => {
    setViewStatus('new');

    const childForCreate = flattenedTree.find((item) => item.key === `${activeItem?.key}-temp`);

    if (childForCreate) {
      setActiveItem(childForCreate);
    }
  };

  return {
    namePath,
    keyPath,
    depth,
    onNewCategoryClick,
    viewStatus,
    setViewStatus,
    onPanelClose,
  };
};

export default useLabelManage;
